import React, { useState, useEffect } from "react";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import { colors } from "../../../../../../../themes/Colors";
import { AddPopUp } from "./components";
import TextInputFieldArea from "../../../../../text-input-field/TextInputFieldArea";
import TextInputField from "../../../../../text-input-field/TextInputField";

const StolenVehicle = ({
  data,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setLoading,
  auth,
}) => {
  const [popUpDisplay, setPopUpDisplay] = useState(false);
  const [stolenVehicle, setStolenVehicle] = useState(null);
  const getStolenVehicleHistory = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/vehicleAction/getStolenVehicleList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleIdentifier: data ? data._id : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setStolenVehicle(respnseData.stolenHistory);

        // setToastPop(true);
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (data) {
      getStolenVehicleHistory();
    }
  }, [data]);
  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        STOLEN VEHCILE HISTORY
      </div>
      {stolenVehicle
        ? stolenVehicle.map((stolen, index) => {
            return (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: index === 0 ? 10 : 0,
                  marginBottom: index === stolenVehicle.length - 1 ? 80 : 0,
                }}
              >
                <div
                  style={{
                    width: "90%",
                    backgroundColor: colors.white,
                    WebkitBoxShadow: "0px 0px 2.5px 0px #00000050",
                    borderRadius: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingBottom: 20,
                  }}
                >
                  <div style={{ width: "95%", marginTop: 10 }}>
                    <TextInputField
                      labelTitle={"TYPE (READ ONLY)"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={"BOLO"}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"GROUP (READ ONLY)"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={"STOLEN VEHICLE"}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"TITLE"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.title}
                    />
                    <div
                      style={{
                        width: "100%",
                        marginTop: 15,
                        marginBottom: 15,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "80%",
                          textAlign: "left",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        VEHICLE DESCRIPTION
                      </div>
                    </div>
                    <TextInputField
                      labelTitle={"Incident Date"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.incidentDate}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Incident Time"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.incidentTime}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Incident Location"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.incidentLocation}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"SAPS case nr"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.SapsCaseNr}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Buzz circulation area"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.buzzCirculationArea}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Vehicle liscense nr"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.vehicleLiscenseNr}
                      readOnly={true}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Make"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={stolen.vehicleMake}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Series"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      readOnly={true}
                      value={stolen.vehicleSeries}
                    />
                    <TextInputField
                      labelTitle={"Vehicle Color"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.vehicleColor}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Person"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.contactPerson}
                      readOnly={true}
                    />

                    <TextInputField
                      labelTitle={"Contact Number"}
                      mini={true}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.contactNumber}
                      readOnly={true}
                    />

                    <TextInputFieldArea
                      mini={true}
                      labelTitle={"ADDITIONAL INFO"}
                      height={100}
                      width={"100%"}
                      size={"80%"}
                      value={stolen.additonalInfo}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
            );
          })
        : null}
      <AddPopUp
        display={popUpDisplay}
        onCloseClick={() => setPopUpDisplay(false)}
        setLoading={setLoading}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        data={data}
        setPopUpDisplay={setPopUpDisplay}
        auth={auth}
      />
      <div
        style={{
          position: "fixed",
          bottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
        }}
      >
        <BaseButtons
          label={"REPORT STOLEN VEHICLE"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={"90%"}
          onClick={() => setPopUpDisplay(true)}
        />
      </div>
    </div>
  );
};

export default StolenVehicle;
